import { useId, type ReactNode } from 'react';
import { cn } from '../lib/utils.js';

/**
 * One labelled group of filter controls inside the panel — "Status", "Labour
 * supplier", "Request type".
 *
 * A real `role="group"` pointing at its own heading, not a styled div, so a
 * screen reader announces which question a chip belongs to. In a panel holding
 * three groups of chips that is the difference between hearing "Late,
 * Unaccounted, On leave, Active, Probation…" and knowing where one group ends.
 */
export interface FiltersGroupProps {
  /** The group's heading. Sentence case — see the note above on 11px caps. */
  title: string;
  children: ReactNode;
  className?: string;
}

export function FiltersGroup({ title, children, className }: FiltersGroupProps): JSX.Element {
  const id = useId();
  return (
    <div role="group" aria-labelledby={id} className={cn('flex flex-col gap-element', className)}>
      <div id={id} className="text-label text-foreground-tertiary">
        {title}
      </div>
      {children}
    </div>
  );
}
